
import { defineComponent } from 'vue';
import OutlineButton from '@/components/ui/OutlineButton.vue';

export default defineComponent({
  name: "ProposalArchivedActions",
  components: {OutlineButton}
})
